'use client'

import { useEffect } from 'react'
import { useCookie } from '@/Cookies/useCookies'
import { useStore } from '@/store'
import { CART_HANDOFF_COOKIE } from '@/lib/auth/marketCookies'

export const CartTokenInitializer = ({
  cartToken,
}: {
  cartToken?: string | null
}) => {
  const setShoppingCartId = useStore(state => state.setShoppingCartId)
  const { setCookie } = useCookie()

  useEffect(() => {
    if (cartToken && cartToken.trim().length > 0) {
      setShoppingCartId(cartToken)
    }

    setCookie(CART_HANDOFF_COOKIE, '', 0)
  }, [cartToken, setCookie, setShoppingCartId])

  return null
}
